/******/ (() => { // webpackBootstrap
/******/ 	"use strict";
/******/ 	var __webpack_modules__ = ({

/***/ "./src/js/cart-api.js":
/*!****************************!*\
  !*** ./src/js/cart-api.js ***!
  \****************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var _formatMoney_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./formatMoney.js */ "./src/js/formatMoney.js");
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }

var createCart = function createCart() {
  var Cart = /*#__PURE__*/function () {
    function Cart() {
      _classCallCheck(this, Cart);
      _defineProperty(this, "triggers", {
        "click": {
          '[data-cart-remove]': 'triggerRemove'
        },
        "change": {
          '[data-cart-quantity]': 'triggerQuantity'
        },
        "submit": {
          '[action="/cart/add"]': 'triggerAdd'
        }
      });
      this.initHandlers();
    }
    return _createClass(Cart, [{
      key: "initHandlers",
      value: function initHandlers() {
        for (var _i = 0, _Object$entries = Object.entries(this.triggers); _i < _Object$entries.length; _i++) {
          var _Object$entries$_i = _slicedToArray(_Object$entries[_i], 2),
            event = _Object$entries$_i[0],
            trigger = _Object$entries$_i[1];
          document.addEventListener(event, function (e) {
            for (var _i2 = 0, _Object$entries2 = Object.entries(this.triggers[e.type]); _i2 < _Object$entries2.length; _i2++) {
              var _Object$entries2$_i = _slicedToArray(_Object$entries2[_i2], 2),
                key = _Object$entries2$_i[0],
                value = _Object$entries2$_i[1];
              var target = e.target.closest(key);
              if (target) {
                this[value](e, target);
              }
            }
          }.bind(this));
        }
      }
    }, {
      key: "cartStartLoading",
      value: function cartStartLoading() {
        var target = document.querySelectorAll('[data-cart-contents]');
        target.forEach(function (el) {
          el.style.pointerEvents = 'none';
          el.style.opacity = 0.5;
        });
      }
    }, {
      key: "cartEndLoading",
      value: function cartEndLoading() {
        var target = document.querySelectorAll('[data-cart-contents]');
        target.forEach(function (el) {
          el.style.pointerEvents = 'auto';
          el.style.opacity = 1;
        });
      }
    }, {
      key: "updateColourCartBag",
      value: function updateColourCartBag(data) {
        var cartBagFillAreas = _toConsumableArray(document.querySelectorAll('[data-cart-count-wrap]'));
        if (data.item_count > 0) {} else {}
      }
    }, {
      key: "cartLineItemSubtotal",
      value: function cartLineItemSubtotal(data) {
        var cartItems = document.querySelectorAll('.cart-item');
        var cartItemsData = data;
        cartItems.forEach(function (cartItem) {
          var cartLineSubtotal = cartItem.querySelector('[data-cart-line-subtotal]');
          var cartItemId = cartItem.getAttribute('data-cart-variant-id');
          if (cartItemsData !== null && cartItemsData !== undefined) {
            cartItemsData.items.map(function (item) {
              if (cartLineSubtotal && item.variant_id == cartItemId) {
                cartLineSubtotal.innerHTML = (0,_formatMoney_js__WEBPACK_IMPORTED_MODULE_0__.formatMoney)(item.final_line_price, data.money_format);
              }
            });
          }
          ;
        });
      }
    }, {
      key: "cartUpsellReveal",
      value: function cartUpsellReveal() {
        //these are only present when on a product page when the upsell trigger is not already in cart
        var hiddenUpsells = document.querySelectorAll('.upsell-slide.hidden');
        if (hiddenUpsells.length > 0) {
          hiddenUpsells.forEach(function (hiddenUpsell) {
            hiddenUpsell.classList.remove('hidden');
          });
        }
      }
    }, {
      key: "cartSummary",
      value: function cartSummary(data) {
        if (data.total_discount > 0) {
          document.querySelectorAll('.js-cart-discount').forEach(function (row) {
            if (row.classList.contains('hidden')) {
              row.classList.remove('hidden');
            }
          });
        } else {
          document.querySelectorAll('.js-cart-discount').forEach(function (row) {
            if (!row.classList.contains('hidden')) {
              row.classList.add('hidden');
            }
          });
        }
        if (data.item_count > 0) {
          document.querySelectorAll('[data-cart-empty]').forEach(function (cartEmpty) {
            return cartEmpty.remove();
          });
          document.querySelector('.cart-upsell').classList.remove('hidden');
          // add section renderer call for upsells here
          this.updateCartUpsells();
          this.cartUpsellReveal();
        } else {
          document.querySelectorAll('[data-cart-contents]').forEach(function (cartContents) {
            if (!cartContents.querySelector('[data-cart-empty]')) {
              cartContents.insertAdjacentHTML("afterbegin", '<p class="block text-[14px] text-center text-[#59595B]">' + 'You have no items in your shopping cart.' + '</p>');
            }
          });
          // if cart is empty, hide upsells
          document.querySelector('.cart-upsell').classList.add('hidden');
        }
        var cartKeyData = {
          '[data-cart-item-count]': data.item_count,
          '[data-cart-subtotal]': (0,_formatMoney_js__WEBPACK_IMPORTED_MODULE_0__.formatMoney)(data.original_total_price, window.money_format),
          '[data-cart-discount]': (0,_formatMoney_js__WEBPACK_IMPORTED_MODULE_0__.formatMoney)(data.total_discount, window.money_format),
          '[data-cart-total]': (0,_formatMoney_js__WEBPACK_IMPORTED_MODULE_0__.formatMoney)(data.total_price, window.money_format)
        };
        var _loop = function _loop() {
          var _Object$entries3$_i = _slicedToArray(_Object$entries3[_i3], 2),
            key = _Object$entries3$_i[0],
            value = _Object$entries3$_i[1];
          document.querySelectorAll(key).forEach(function (item) {
            item.innerHTML = value;
          });
        };
        for (var _i3 = 0, _Object$entries3 = Object.entries(cartKeyData); _i3 < _Object$entries3.length; _i3++) {
          _loop();
        }
      }
    }, {
      key: "cartContents",
      value: function cartContents() {
        var _this = this;
        fetch(window.Shopify.routes.root + 'cart.js').then(function (response) {
          return response.json();
        }).then(function (data) {
          _this.cartSummary(data);
        });
      }
    }, {
      key: "redrawCartPartial",
      value: function redrawCartPartial(data) {
        var parser = new DOMParser();
        var html = parser.parseFromString(data, 'text/html');
        document.querySelectorAll('.cart-item').forEach(function (cartItem) {
          var variantID = cartItem.getAttribute('data-cart-variant-id');
          var cartItemDetails = html.querySelector(".cart-item[data-cart-variant-id=\"".concat(variantID, "\"] .cart-item-content")).innerHTML;
          var cartItemContent = cartItem.querySelector('.cart-item-content');
          if (!cartItemContent) return;
          cartItemContent.innerHTML = cartItemDetails;
          if (cartItem.getAttribute('data-tags') === 'only') {
            var quantityInput = cartItemContent.querySelector('[data-cart-quantity]');
            if (quantityInput) {
              quantityInput.value = 1;
              quantityInput.setAttribute('disabled', 'disabled');
            }
          }
        });
      }
    }, {
      key: "redrawCart",
      value: function redrawCart(cartFunction) {
        var _this2 = this;
        fetch(window.Shopify.routes.root + 'cart?view=ajax').then(function (response) {
          return response.text();
        }).then(function (data) {
          if (cartFunction == 'update') {
            _this2.redrawCartPartial(data);
          } else {
            document.querySelectorAll('[data-cart-contents]').forEach(function (cartContent) {
              cartContent.innerHTML = data;
            });
            var sideCart = document.querySelector('.side-cart');
            sideCart.classList.add('active');
            document.body.classList.add('overflow-hidden');
          }
        });
      }
    }, {
      key: "cartProductRemove",
      value: function cartProductRemove(variantID) {
        document.querySelectorAll(".cart-item[data-cart-variant-id=\"".concat(variantID, "\"]")).forEach(function (item) {
          item.remove();
        });
      }
    }, {
      key: "cartUpdate",
      value: function cartUpdate(variantID, quantity) {
        var _this3 = this;
        var callback = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
        var formData = {
          updates: {}
        };
        formData.updates[variantID] = quantity;
        fetch(window.Shopify.routes.root + 'cart/update.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json'
          },
          body: JSON.stringify(formData)
        }).then(function (response) {
          return response.json();
        }).then(function (data) {
          if (callback !== null) {
            callback(data);
          }
          _this3.cartSummary(data);
          _this3.cartLineItemSubtotal(data);
        })["catch"](function (error) {
          console.error('Error:', error);
        });
      }
    }, {
      key: "cartUpsellProductAdd",
      value: function cartUpsellProductAdd(productId) {
        var upsellCard = document.querySelector(".cart-upsell [data-id=\"".concat(productId, "\"]"));
        //let upsellCardForm = upsellCard.querySelector('.product-upsell-form');
        if (upsellCard) {
          //upsellCard.classList.add('hidden');
          //upsellCardForm.classList.add('hidden');
        }
      }
    }, {
      key: "cartUpsellProductRemove",
      value: function cartUpsellProductRemove(productId) {
        var upsellCard = document.querySelector(".cart-upsell [data-id=\"".concat(productId, "\"]"));
        //let upsellCardForm = upsellCard.querySelector('.product-upsell-form');
        if (upsellCard) {
          //upsellCard.classList.remove('hidden');
          //upsellCardForm.classList.add('hidden');
        }
      }

      //refresh the cart upsells via ajax request to ajax request
    }, {
      key: "updateCartUpsells",
      value: function updateCartUpsells() {
        console.log('update cart upsells running');
        var url = '/cart?section_id=ajax-cart-upsells';
        fetch(url).then(function (response) {
          return response.text();
        }).then(function (html) {
          var upsellContainer = document.querySelector('#cart-upsells-container');
          if (upsellContainer) {
            console.log('upsell container found and replaced');
            upsellContainer.innerHTML = html;
          } else {
            console.log('upsell container not found');
          }
        })["catch"](function (error) {
          console.error('Error updating cart upsells:', error);
        });
      }
    }, {
      key: "triggerRemove",
      value: function triggerRemove(event, element) {
        var productId = element.closest('.cart-item').getAttribute('data-product-id');
        var variantID = element.closest('.cart-item').getAttribute('data-cart-variant-id');
        event.preventDefault();
        this.cartStartLoading();
        this.cartUpdate(variantID, 0, function (response) {
          this.redrawCart('update');
          this.cartProductRemove(variantID);
          this.updateColourCartBag(response);
          this.cartEndLoading();
          this.cartUpsellProductRemove(productId);
        }.bind(this));
      }
    }, {
      key: "triggerQuantity",
      value: function triggerQuantity(event, element) {
        var variantID = element.closest('.cart-item').getAttribute('data-cart-variant-id');
        this.cartStartLoading();
        this.cartUpdate(variantID, element.value, function (response) {
          this.redrawCart('update');
          this.cartLineItemSubtotal();
          this.cartEndLoading();
        }.bind(this));
      }
    }, {
      key: "displayMessage",
      value: function displayMessage(message, type) {
        // Check if data-active-sticky-cart exists on the page.
        var stickyCartElement = document.querySelector('[data-active-sticky-cart]');
        if (!stickyCartElement) {
          console.warn('One size per transaction limit');
          return;
        }
        var existingMessage = document.querySelector('[data-message-flag]');
        if (existingMessage) return;
        var messageElement = document.createElement('div');
        var svgIcon = "\n                <svg aria-hidden=\"true\" focusable=\"false\" role=\"presentation\" class=\"w-4 mr-2\" viewBox=\"0 0 13 13\">\n                <circle cx=\"6.5\" cy=\"6.50049\" r=\"5.5\" stroke=\"#000\" stroke-width=\"2\"/>\n                <circle cx=\"6.5\" cy=\"6.5\" r=\"5.5\" fill=\"#000\" stroke=\"#000\" stroke-width=\"0.7\"/>\n                <path d=\"M5.87413 3.52832L5.97439 7.57216H7.02713L7.12739 3.52832H5.87413ZM6.50076 9.66091C6.88091 9.66091 7.18169 9.37267 7.18169 9.00504C7.18169 8.63742 6.88091 8.34917 6.50076 8.34917C6.12061 8.34917 5.81982 8.63742 5.81982 9.00504C5.81982 9.37267 6.12061 9.66091 6.50076 9.66091Z\" fill=\"#000\"/>\n                <path d=\"M5.87413 3.17832H5.51535L5.52424 3.537L5.6245 7.58083L5.63296 7.92216H5.97439H7.02713H7.36856L7.37702 7.58083L7.47728 3.537L7.48617 3.17832H7.12739H5.87413ZM6.50076 10.0109C7.06121 10.0109 7.5317 9.57872 7.5317 9.00504C7.5317 8.43137 7.06121 7.99918 6.50076 7.99918C5.94031 7.99918 5.46982 8.43137 5.46982 9.00504C5.46982 9.57872 5.94031 10.0109 6.50076 10.0109Z\" fill=\"white\" stroke=\"#000\" stroke-width=\"0.7\">\n                </svg>\n            ";
        messageElement.innerHTML = svgIcon + message;
        messageElement.className = "\n            relative px-4 py-2 text-center mb-2 flex items-center justify-center ".concat(type === 'alert' ? 'bg-red-100 text-black text-xs' : 'bg-green-500 text-white text-xs', "\n            ");
        messageElement.setAttribute('data-message-flag', '');
        // Append the message to the sticky cart.
        stickyCartElement.appendChild(messageElement);
        setTimeout(function () {
          messageElement.remove();
        }, 4000);
      }
    }, {
      key: "triggerAdd",
      value: function triggerAdd(event, element) {
        var _this4 = this;
        console.log('triggerAdd running');
        event.preventDefault();
        var formData = new FormData(element);
        var variantID = formData.get('id');
        var productId = formData.get('product-id');
        var formSubmit = element.querySelector('[data-addto-cart-btn]');
        var formSubmitText = formSubmit.querySelector('span');
        formSubmit.setAttribute('disabled', 'disabled');
        formSubmitText.innerHTML = 'Adding';
        var variantInCart = document.querySelector("[data-cart-variant-id=\"".concat(variantID, "\"]"));
        var hasNoLimit = variantInCart ? variantInCart.hasAttribute('data-nolimit') : false;
        if (variantInCart && !hasNoLimit) {
          this.displayMessage('One size per transaction limit', 'alert');
          setTimeout(function () {
            formSubmit.removeAttribute('disabled');
            formSubmitText.innerHTML = 'Add to Cart';
          }, 2000);
        } else {
          fetch(window.Shopify.routes.root + 'cart/add.js', {
            method: 'POST',
            body: formData
          }).then(function (response) {
            return response.json();
          }).then(function (data) {
            document.querySelectorAll('[data-cart-empty]').forEach(function (cartEmpty) {
              return cartEmpty.remove();
            });
            _this4.redrawCart();
            _this4.cartContents();
            setTimeout(function () {
              formSubmit.removeAttribute('disabled');
              formSubmitText.innerHTML = 'Add to Cart';
            }, 500);
            _this4.cartUpsellProductAdd(productId);
          })["catch"](function (error) {
            console.error('Error:', error);
          });
        }
      }
    }]);
  }();
  return new Cart();
};
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (createCart);

/***/ }),

/***/ "./src/js/core.js":
/*!************************!*\
  !*** ./src/js/core.js ***!
  \************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _cart_api_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./cart-api.js */ "./src/js/cart-api.js");
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _wrapNativeSuper(t) { var r = "function" == typeof Map ? new Map() : void 0; return _wrapNativeSuper = function _wrapNativeSuper(t) { if (null === t || !_isNativeFunction(t)) return t; if ("function" != typeof t) throw new TypeError("Super expression must either be null or a function"); if (void 0 !== r) { if (r.has(t)) return r.get(t); r.set(t, Wrapper); } function Wrapper() { return _construct(t, arguments, _getPrototypeOf(this).constructor); } return Wrapper.prototype = Object.create(t.prototype, { constructor: { value: Wrapper, enumerable: !1, writable: !0, configurable: !0 } }), _setPrototypeOf(Wrapper, t); }, _wrapNativeSuper(t); }
function _construct(t, e, r) { if (_isNativeReflectConstruct()) return Reflect.construct.apply(null, arguments); var o = [null]; o.push.apply(o, e); var p = new (t.bind.apply(t, o))(); return r && _setPrototypeOf(p, r.prototype), p; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _isNativeFunction(t) { try { return -1 !== Function.toString.call(t).indexOf("[native code]"); } catch (n) { return "function" == typeof t; } }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function mobileMenu() {
  window.openMenu = function () {
    document.body.classList.add("open-mobilemenu");
    document.dispatchEvent(new CustomEvent('menuOpened'));
  };
  window.closeMenu = function (event) {
    if (event) event.stopPropagation();
    document.body.classList.remove("open-mobilemenu");
  };
  var navExpand = [].slice.call(document.querySelectorAll('.nav-expand'));
  var accountMenu = document.querySelector('.account-menu');
  navExpand.forEach(function (item) {
    item.querySelector('.nav-link').addEventListener('click', function () {
      requestAnimationFrame(function () {
        item.classList.add('active');
        accountMenu.classList.add('hidden');
      });
    });
    item.querySelector('.nav-back-link').addEventListener('click', function () {
      requestAnimationFrame(function () {
        item.classList.remove('active');
        accountMenu.classList.remove('hidden');
      });
    });
  });
}
function siteFooter() {
  window.addEventListener("DOMContentLoaded", function (event) {
    var accordions = Array.from(document.getElementsByClassName('menu-footer'));
    var handleAccordionClick = function handleAccordionClick(event) {
      var content = event.target.nextElementSibling;
      var plusIcon = event.target.getElementsByClassName('icon-plus')[0];
      var minusIcon = event.target.getElementsByClassName('icon-minus')[0];
      if (window.innerWidth <= 768) {
        event.target.classList.toggle('active');
        if (event.target.classList.contains('active')) {
          content.style.maxHeight = content.scrollHeight + 'px';
          plusIcon.style.display = 'none';
          minusIcon.style.display = 'inline-block';
        } else {
          content.style.maxHeight = null;
          plusIcon.style.display = 'inline-block';
          minusIcon.style.display = 'none';
        }
      }
    };
    accordions.forEach(function (accordion) {
      var heading = accordion.getElementsByClassName('menu-footer-heading')[0];
      heading.addEventListener('click', handleAccordionClick);
    });
    var handleResize = function handleResize() {
      if (window.innerWidth > 768) {
        accordions.forEach(function (accordion) {
          var heading = accordion.getElementsByClassName('menu-footer-heading')[0];
          var content = heading.nextElementSibling;
          var plusIcon = heading.getElementsByClassName('icon-plus')[0];
          var minusIcon = heading.getElementsByClassName('icon-minus')[0];
          heading.classList.remove('active');
          content.style.maxHeight = null;
          plusIcon.style.display = 'inline-block';
          minusIcon.style.display = 'none';
        });
      }
    };
    handleResize(); // Call once on page load
    window.addEventListener('resize', handleResize);
  });
}
function sidePanels() {
  var overlay = document.getElementById('overlay');
  window.openPopup = function (popupId) {
    var popup = document.getElementById(popupId);
    popup.classList.remove("panel-inactive");
    popup.classList.add("panel-active");
    overlay.classList.remove("overlay-inactive");
    overlay.classList.add("overlay-active");
    document.body.classList.add("overflow-hidden");
    overlay.dataset.target = popupId;
  };
  window.closePopup = function (event, popupId) {
    if (event) event.stopPropagation();
    var targetPopupId = popupId || overlay.dataset.target;
    var popup = document.getElementById(targetPopupId);
    popup.classList.remove("panel-active");
    popup.classList.add("panel-inactive");
    overlay.classList.remove("overlay-active");
    overlay.classList.add("overlay-inactive");
    document.body.classList.remove("overflow-hidden");

    // unset the target after the popup has been closed
    delete overlay.dataset.target;
  };
  document.addEventListener('DOMContentLoaded', function () {
    var tabs = document.querySelectorAll('.tabs .tab');
    tabs.forEach(function (tab) {
      tab.addEventListener('click', function () {
        document.querySelectorAll('.tabs .tab').forEach(function (tab) {
          tab.classList.remove('border-black');
          tab.classList.remove('text-black');
        });
        tab.classList.add('border-black');
        tab.classList.add('text-black');
        var tabContent = document.querySelectorAll('.tab-content');
        tabContent.forEach(function (content) {
          content.classList.add('hidden');
        });
        var tabId = this.getAttribute('data-tab');
        document.getElementById(tabId).classList.remove('hidden');
      });
    });
  });
}
function backToTop() {
  document.addEventListener('DOMContentLoaded', function () {
    var btn = document.getElementById('back-to-top');
    var viewportHeight = window.innerHeight / 2 || document.documentElement.clientHeight / 2;

    // Adding event listener for scroll event
    window.addEventListener('scroll', function () {
      if (window.scrollY > viewportHeight) {
        btn.style.display = 'flex';
      } else {
        btn.style.display = 'none';
      }
    });
    btn.addEventListener('click', function (e) {
      e.preventDefault();
      window.scrollTo({
        top: 0,
        behavior: 'smooth'
      });
    });
  });
}
// function brandFiltersMegamenu (){
//     document.querySelectorAll('.alphabet-filter-block').forEach(filterBlock => {

//         let letters = filterBlock.querySelectorAll('.main-brand-letter');
//         let brandSections = filterBlock.querySelectorAll('.main-brands-section');
//         letters.forEach(letter => {
//             let letterBrands = filterBlock.querySelector('.main-brands-' + letter.dataset.letter + ' .brand-item');
//             if (!letterBrands) {
//                 letter.classList.add('opacity-30', 'pointer-events-none');
//             }
//         });
//         letters.forEach(letter => {
//             letter.addEventListener('click', function (e) {
//                 e.preventDefault();
//                 let letterBrands = filterBlock.querySelector('.main-brands-' + letter.dataset.letter + ' .brand-item');

//                 if (!letterBrands) {
//                     letter.classList.add('text-gray-300', 'pointer-events-none');
//                 }

//                 let clickedLetter = this.dataset.letter;

//                 letters.forEach(letter => {
//                     letter.classList.remove('active');
//                 });
//                 this.classList.add('active');

//                 brandSections.forEach(section => {
//                     section.classList.remove('flex');
//                     section.classList.add('hidden');
//                 });

//                 let targetSection = filterBlock.querySelector('.main-brands-' + clickedLetter);
//                 targetSection.classList.remove('hidden');
//                 targetSection.classList.add('flex');

//                 let brandsList = targetSection.querySelector('.main-brands-list');
//                 let brands = targetSection.querySelectorAll('.main-brands-list li').length;

//                 if (brands > 6) {
//                     brandsList.classList.add('lg:grid-cols-2');
//                 } else {
//                     brandsList.classList.remove('lg:grid-cols-2');
//                 }

//                 let noBrandsMessage = targetSection.querySelector('.no-brands');
// 				if (noBrandsMessage) {
// 					if (brands === 0) {
// 						noBrandsMessage.classList.remove('hidden');
// 					} else {
// 						noBrandsMessage.classList.add('hidden');
// 					}
// 				}
//             });
//         });

//         window.addEventListener('DOMContentLoaded', (event) => {
//             brandSections.forEach(section => {
//                 if (section.dataset.letter !== 'A') {
//                     section.classList.add('hidden');
//                 } else {
//                     section.classList.remove('hidden');
//                     section.classList.add('flex');
//                 }
//             });

//             filterBlock.querySelector('.main-brand-letter[data-letter="A"]').classList.add('active');
//         });
//     });
// }

function brandFiltersMegamenu() {
  document.querySelectorAll('.alphabet-filter-block').forEach(function (filterBlock) {
    var letters = filterBlock.querySelectorAll('.main-brand-letter');
    var brands = filterBlock.querySelectorAll('.brand-item');

    // Disable letters with no brands
    letters.forEach(function (letter) {
      var hasBrands = filterBlock.querySelector(".brand-item[data-letter=\"".concat(letter.dataset.letter, "\"]"));
      if (!hasBrands) {
        letter.classList.add('opacity-30', 'pointer-events-none');
      }
    });
    letters.forEach(function (letter) {
      letter.addEventListener('click', function (e) {
        e.preventDefault();
        var clickedLetter = letter.dataset.letter;
        letters.forEach(function (l) {
          return l.classList.remove('active');
        });
        letter.classList.add('active');
        var visibleCount = 0;
        brands.forEach(function (brand) {
          var match = brand.dataset.letter === clickedLetter;
          brand.classList.toggle('hidden', !match);
          if (match) visibleCount++;
        });
        var brandsList = filterBlock.querySelector('.brands-flat');
        if (visibleCount > 6) {
          brandsList.classList.add('lg:grid-cols-2');
        } else {
          brandsList.classList.remove('lg:grid-cols-2');
        }
      });
    });

    // Default to A
    var defaultLetter = 'A';
    brands.forEach(function (brand) {
      brand.classList.toggle('hidden', brand.dataset.letter !== defaultLetter);
    });
    var defaultBtn = filterBlock.querySelector(".main-brand-letter[data-letter=\"".concat(defaultLetter, "\"]"));
    if (defaultBtn) defaultBtn.classList.add('active');
  });
}
function brandFiltersHomepage() {
  document.querySelectorAll('.alphabet-filter-block-homepage').forEach(function (filterBlock) {
    var letters = filterBlock.querySelectorAll('.main-brand-letter');
    var brandSections = filterBlock.querySelectorAll('.main-brands-section');
    letters.forEach(function (letter) {
      var letterBrands = filterBlock.querySelector('.main-brands-' + letter.dataset.letter + ' .brand-item');
      if (!letterBrands) {
        letter.classList.add('opacity-30', 'pointer-events-none');
      }
    });
    letters.forEach(function (letter) {
      letter.addEventListener('click', function (e) {
        e.preventDefault();
        var letterBrands = filterBlock.querySelector('.main-brands-' + letter.dataset.letter + ' .brand-item');
        if (!letterBrands) {
          letter.classList.add('text-gray-300', 'pointer-events-none');
        }
        var clickedLetter = this.dataset.letter;
        letters.forEach(function (letter) {
          letter.classList.remove('active');
        });
        this.classList.add('active');
        brandSections.forEach(function (section) {
          section.classList.remove('flex');
          section.classList.add('hidden');
        });
        var targetSection = filterBlock.querySelector('.main-brands-' + clickedLetter);
        targetSection.classList.remove('hidden');
        targetSection.classList.add('flex');
        var brands = targetSection.querySelectorAll('.main-brands-list li').length;
        var noBrandsMessage = targetSection.querySelector('.no-brands');
        if (noBrandsMessage) {
          if (brands === 0) {
            noBrandsMessage.classList.remove('hidden');
          } else {
            noBrandsMessage.classList.add('hidden');
          }
        }
      });
    });
  });
}
function toggleShowMore() {
  var showMoreButtons = document.querySelectorAll('.show-more-button');
  showMoreButtons.forEach(function (button) {
    button.addEventListener('click', function () {
      var shortTextDiv = this.previousElementSibling.previousElementSibling;
      var moreTextDiv = this.previousElementSibling;
      var moreText = this.dataset.showMoreText;
      var lessText = this.dataset.showLessText;
      if (this.dataset.more === '0') {
        shortTextDiv.classList.add('hidden');
        moreTextDiv.classList.remove('hidden');
        this.dataset.more = '1';
        this.innerText = lessText;
      } else {
        shortTextDiv.classList.remove('hidden');
        moreTextDiv.classList.add('hidden');
        this.dataset.more = '0';
        this.innerText = moreText;
      }
    });
  });
}

// Initialize the function
window.addEventListener('DOMContentLoaded', toggleShowMore);
var LocalizationForm = /*#__PURE__*/function (_HTMLElement) {
  function LocalizationForm() {
    var _this;
    _classCallCheck(this, LocalizationForm);
    _this = _callSuper(this, LocalizationForm);
    _this.elements = {
      input: _this.querySelector('input[name="language_code"], input[name="currency_code"]'),
      button: _this.querySelector('button'),
      panel: _this.querySelector('ul')
    };
    _this.elements.button.addEventListener('click', _this.openSelector.bind(_this));
    _this.elements.button.addEventListener('focusout', _this.closeSelector.bind(_this));
    _this.addEventListener('keyup', _this.onContainerKeyUp.bind(_this));
    _this.querySelectorAll('.localization-language').forEach(function (item) {
      return item.addEventListener('click', _this.onItemClick.bind(_this));
    });
    return _this;
  }
  _inherits(LocalizationForm, _HTMLElement);
  return _createClass(LocalizationForm, [{
    key: "hidePanel",
    value: function hidePanel() {
      this.elements.button.setAttribute('aria-expanded', 'false');
      this.elements.panel.setAttribute('hidden', true);
    }
  }, {
    key: "onContainerKeyUp",
    value: function onContainerKeyUp(event) {
      if (event.code.toUpperCase() !== 'ESCAPE') return;
      this.hidePanel();
      this.elements.button.focus();
    }
  }, {
    key: "onItemClick",
    value: function onItemClick(event) {
      event.preventDefault();
      var form = this.querySelector('form');
      this.elements.input.value = event.currentTarget.dataset.value;
      if (form) form.submit();
    }
  }, {
    key: "openSelector",
    value: function openSelector() {
      this.elements.button.focus();
      this.elements.panel.toggleAttribute('hidden');
      this.elements.button.setAttribute('aria-expanded', (this.elements.button.getAttribute('aria-expanded') === 'false').toString());
    }
  }, {
    key: "closeSelector",
    value: function closeSelector(event) {
      var shouldClose = event.relatedTarget && event.relatedTarget.nodeName === 'BUTTON';
      if (event.relatedTarget === null || shouldClose) {
        this.hidePanel();
      }
    }
  }]);
}(/*#__PURE__*/_wrapNativeSuper(HTMLElement));
customElements.define('localization-form', LocalizationForm);
brandFiltersHomepage();
brandFiltersMegamenu();
sidePanels();
backToTop();
siteFooter();
mobileMenu();

window.cart = (0,_cart_api_js__WEBPACK_IMPORTED_MODULE_0__["default"])();
document.addEventListener('DOMContentLoaded', function () {
  document.addEventListener('click', function (event) {
    if (event.target.closest('[data-cart-drawer-toggle]')) {
      event.preventDefault();
      var sideCart = document.querySelector('.side-cart');
      if (sideCart) {
        if (sideCart.classList.contains('active')) {
          sideCart.classList.remove('active');
          document.body.classList.remove('overflow-hidden');
        } else {
          sideCart.classList.add('active');
          document.body.classList.add('overflow-hidden');
          //only show the upsells if there are items in the cart
          if (document.querySelector('.cart-item')) {
            document.querySelector('.cart-upsell').classList.remove('hidden');
          }
        }
      }
    }
  });
});
// JavaScript file
/*mf-removed - was breaking headers
document.addEventListener("DOMContentLoaded", function () {
    // Function to check and remove the headers
    function checkAndRemoveHeaders() {
        if (window.innerWidth > 1023) {
            // If screen size is above 700px, remove .header-mobile
            var headerMobile = document.querySelector('.section-header-mobile');
            if (headerMobile) {
                headerMobile.remove();
            }
        } else {
            // If screen size is 700px or less, remove .header-desktop
            var headerDesktop = document.querySelector('.header-bottom');
            if (headerDesktop) {
                headerDesktop.remove();
            }
        }
    }

    // Initial check
    checkAndRemoveHeaders();

    // Add event listener for window resize
    window.addEventListener('resize', checkAndRemoveHeaders);
});
*/

// document.addEventListener("DOMContentLoaded", function () {
//     var upsellCards = document.querySelectorAll('.product-upsell-card');

//     upsellCards.forEach(function (card) {
//         card.addEventListener('click', function () {
//             // Toggle the hidden class for the clicked card
//             var form = card.querySelector('.product-upsell-form');
//             if (form) {
//                 form.classList.toggle('hidden');
//             }

//             // Reset (i.e., add the hidden class) for all other cards
//             upsellCards.forEach(function (otherCard) {
//                 if (otherCard !== card) {
//                     var otherForm = otherCard.querySelector('.product-upsell-form');
//                     if (otherForm) {
//                         otherForm.classList.add('hidden');
//                     }
//                 }
//             });
//         });

//         // Stop event propagation for .product-variant and .add-to-cart-btn
//         var variants = card.querySelectorAll('.product-variant');
//         var addToCartButtons = card.querySelectorAll('.add-to-cart-btn');

//         variants.forEach(function (variant) {
//             variant.addEventListener('click', function (event) {
//                 event.stopPropagation();
//             });
//         });

//         addToCartButtons.forEach(function (button) {
//             button.addEventListener('click', function (event) {
//                 event.stopPropagation();
//             });
//         });
//     });
// });

/***/ }),

/***/ "./src/js/formatMoney.js":
/*!*******************************!*\
  !*** ./src/js/formatMoney.js ***!
  \*******************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "formatMoney": () => (/* binding */ formatMoney)
/* harmony export */ });
function formatMoney(cents, format) {
  if (typeof cents == 'string') {
    cents = cents.replace('.', '');
  }
  var value = '';
  var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
  var formatString = format || "${{amount}}";
  function defaultOption(opt, def) {
    return typeof opt == 'undefined' ? def : opt;
  }
  function formatWithDelimiters(number, precision, thousands, decimal) {
    precision = defaultOption(precision, 2);
    thousands = defaultOption(thousands, ',');
    decimal = defaultOption(decimal, '.');
    if (isNaN(number) || number == null) {
      return 0;
    }
    number = (number / 100.0).toFixed(precision);
    var parts = number.split('.'),
      dollars = parts[0],
      cents = parts[1] && parts[1] !== '00' ? '.' + parts[1] : '';
    return dollars + cents;
  }
  switch (formatString.match(placeholderRegex)[1]) {
    case 'amount':
      value = formatWithDelimiters(cents, 2);
      break;
    case 'amount_no_decimals':
      value = formatWithDelimiters(cents, 0);
      break;
    case 'amount_with_comma_separator':
      value = formatWithDelimiters(cents, 2, '.', ',');
      break;
    case 'amount_no_decimals_with_comma_separator':
      value = formatWithDelimiters(cents, 0, '.', ',');
      break;
    case "amount_with_apostrophe_separator":
      value = formatWithDelimiters(cents, 2, "'", ".");
      break;
  }
  return formatString.replace(placeholderRegex, value);
}
;

/***/ }),

/***/ "./src/css/core.css":
/*!**************************!*\
  !*** ./src/css/core.css ***!
  \**************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
// extracted by mini-css-extract-plugin


/***/ })

/******/ 	});
/************************************************************************/
/******/ 	// The module cache
/******/ 	var __webpack_module_cache__ = {};
/******/ 	
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/ 		// Check if module is in cache
/******/ 		var cachedModule = __webpack_module_cache__[moduleId];
/******/ 		if (cachedModule !== undefined) {
/******/ 			return cachedModule.exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = __webpack_module_cache__[moduleId] = {
/******/ 			// no module.id needed
/******/ 			// no module.loaded needed
/******/ 			exports: {}
/******/ 		};
/******/ 	
/******/ 		// Execute the module function
/******/ 		__webpack_modules__[moduleId](module, module.exports, __webpack_require__);
/******/ 	
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/ 	
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = __webpack_modules__;
/******/ 	
/************************************************************************/
/******/ 	/* webpack/runtime/chunk loaded */
/******/ 	(() => {
/******/ 		var deferred = [];
/******/ 		__webpack_require__.O = (result, chunkIds, fn, priority) => {
/******/ 			if(chunkIds) {
/******/ 				priority = priority || 0;
/******/ 				for(var i = deferred.length; i > 0 && deferred[i - 1][2] > priority; i--) deferred[i] = deferred[i - 1];
/******/ 				deferred[i] = [chunkIds, fn, priority];
/******/ 				return;
/******/ 			}
/******/ 			var notFulfilled = Infinity;
/******/ 			for (var i = 0; i < deferred.length; i++) {
/******/ 				var [chunkIds, fn, priority] = deferred[i];
/******/ 				var fulfilled = true;
/******/ 				for (var j = 0; j < chunkIds.length; j++) {
/******/ 					if ((priority & 1 === 0 || notFulfilled >= priority) && Object.keys(__webpack_require__.O).every((key) => (__webpack_require__.O[key](chunkIds[j])))) {
/******/ 						chunkIds.splice(j--, 1);
/******/ 					} else {
/******/ 						fulfilled = false;
/******/ 						if(priority < notFulfilled) notFulfilled = priority;
/******/ 					}
/******/ 				}
/******/ 				if(fulfilled) {
/******/ 					deferred.splice(i--, 1)
/******/ 					var r = fn();
/******/ 					if (r !== undefined) result = r;
/******/ 				}
/******/ 			}
/******/ 			return result;
/******/ 		};
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/define property getters */
/******/ 	(() => {
/******/ 		// define getter functions for harmony exports
/******/ 		__webpack_require__.d = (exports, definition) => {
/******/ 			for(var key in definition) {
/******/ 				if(__webpack_require__.o(definition, key) && !__webpack_require__.o(exports, key)) {
/******/ 					Object.defineProperty(exports, key, { enumerable: true, get: definition[key] });
/******/ 				}
/******/ 			}
/******/ 		};
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/hasOwnProperty shorthand */
/******/ 	(() => {
/******/ 		__webpack_require__.o = (obj, prop) => (Object.prototype.hasOwnProperty.call(obj, prop))
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/make namespace object */
/******/ 	(() => {
/******/ 		// define __esModule on exports
/******/ 		__webpack_require__.r = (exports) => {
/******/ 			if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
/******/ 				Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
/******/ 			}
/******/ 			Object.defineProperty(exports, '__esModule', { value: true });
/******/ 		};
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/jsonp chunk loading */
/******/ 	(() => {
/******/ 		// no baseURI
/******/ 		
/******/ 		// object to store loaded and loading chunks
/******/ 		// undefined = chunk not loaded, null = chunk preloaded/prefetched
/******/ 		// [resolve, reject, Promise] = chunk loading, 0 = chunk loaded
/******/ 		var installedChunks = {
/******/ 			"/core": 0,
/******/ 			"core": 0
/******/ 		};
/******/ 		
/******/ 		// no chunk on demand loading
/******/ 		
/******/ 		// no prefetching
/******/ 		
/******/ 		// no preloaded
/******/ 		
/******/ 		// no HMR
/******/ 		
/******/ 		// no HMR manifest
/******/ 		
/******/ 		__webpack_require__.O.j = (chunkId) => (installedChunks[chunkId] === 0);
/******/ 		
/******/ 		// install a JSONP callback for chunk loading
/******/ 		var webpackJsonpCallback = (parentChunkLoadingFunction, data) => {
/******/ 			var [chunkIds, moreModules, runtime] = data;
/******/ 			// add "moreModules" to the modules object,
/******/ 			// then flag all "chunkIds" as loaded and fire callback
/******/ 			var moduleId, chunkId, i = 0;
/******/ 			if(chunkIds.some((id) => (installedChunks[id] !== 0))) {
/******/ 				for(moduleId in moreModules) {
/******/ 					if(__webpack_require__.o(moreModules, moduleId)) {
/******/ 						__webpack_require__.m[moduleId] = moreModules[moduleId];
/******/ 					}
/******/ 				}
/******/ 				if(runtime) var result = runtime(__webpack_require__);
/******/ 			}
/******/ 			if(parentChunkLoadingFunction) parentChunkLoadingFunction(data);
/******/ 			for(;i < chunkIds.length; i++) {
/******/ 				chunkId = chunkIds[i];
/******/ 				if(__webpack_require__.o(installedChunks, chunkId) && installedChunks[chunkId]) {
/******/ 					installedChunks[chunkId][0]();
/******/ 				}
/******/ 				installedChunks[chunkId] = 0;
/******/ 			}
/******/ 			return __webpack_require__.O(result);
/******/ 		}
/******/ 		
/******/ 		var chunkLoadingGlobal = self["webpackChunkZG_A"] = self["webpackChunkZG_A"] || [];
/******/ 		chunkLoadingGlobal.forEach(webpackJsonpCallback.bind(null, 0));
/******/ 		chunkLoadingGlobal.push = webpackJsonpCallback.bind(null, chunkLoadingGlobal.push.bind(chunkLoadingGlobal));
/******/ 	})();
/******/ 	
/************************************************************************/
/******/ 	
/******/ 	// startup
/******/ 	// Load entry module and return exports
/******/ 	// This entry module depends on other loaded chunks and execution need to be delayed
/******/ 	__webpack_require__.O(undefined, ["core"], () => (__webpack_require__("./src/js/core.js")))
/******/ 	var __webpack_exports__ = __webpack_require__.O(undefined, ["core"], () => (__webpack_require__("./src/css/core.css")))
/******/ 	__webpack_exports__ = __webpack_require__.O(__webpack_exports__);
/******/ 	
/******/ })()
;